import EventBus from '../../../functions/event-bus'

function showAccordionLink (id) {
  const accordionLinks = document.querySelectorAll('.js-accordion-link')
  accordionLinks.forEach(link => link.classList.remove('is-active'))

  const accordionLink = document.querySelector(`[data-accordion="${id}"]`)
  const accordionLinkEmpty = document.querySelector('.js-accordion-link-empty')

  if (accordionLink) {
    accordionLink.classList.add('is-active')
    accordionLinkEmpty.classList.add('is-hidden')
  } else if (accordionLinkEmpty) {
    accordionLinkEmpty.classList.remove('is-hidden')
  }
}

EventBus.subscribe('accordion', showAccordionLink)
